import { styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const OptionWraper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const OptionTitle = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",

  "&:hover": {
    color: `${colors.gray600} !important`,
  },
}));

export const OptionSubtitle = styled("span")(() => ({
  overflow: "hidden",
  color: colors.gray500,
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",

  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",

  "&:hover": {
    color: `${colors.gray500} !important`,
  },
}));
